import { StatsPerCategorySection } from "./StatsPerCategorySection";

export * from "./StatsPerCategorySection";
export default StatsPerCategorySection;
